<template>
  <trainer3 @success="$emit('success')"/>
</template>
<script>
import trainer3 from '@/views/lesson1/components/trainer3/trainer3'

export default {
  name: 'trainer1',
  components: { trainer3 },
}
</script>
